export default __webpack_public_path__ + "static/media/add.8a5474ac.svg";